export default __webpack_public_path__ + "static/media/hassan.1f4e9210.jpg";